webpackJsonp([32],{

/***/ 408:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Driver_vue__ = __webpack_require__(740);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d66ea3d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Driver_vue__ = __webpack_require__(931);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Driver_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d66ea3d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Driver_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(469));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(468));

var _alphaNum = _interopRequireDefault(__webpack_require__(471));

var _numeric = _interopRequireDefault(__webpack_require__(472));

var _between = _interopRequireDefault(__webpack_require__(473));

var _email = _interopRequireDefault(__webpack_require__(474));

var _ipAddress = _interopRequireDefault(__webpack_require__(475));

var _macAddress = _interopRequireDefault(__webpack_require__(476));

var _maxLength = _interopRequireDefault(__webpack_require__(477));

var _minLength = _interopRequireDefault(__webpack_require__(478));

var _required = _interopRequireDefault(__webpack_require__(479));

var _requiredIf = _interopRequireDefault(__webpack_require__(480));

var _requiredUnless = _interopRequireDefault(__webpack_require__(481));

var _sameAs = _interopRequireDefault(__webpack_require__(482));

var _url = _interopRequireDefault(__webpack_require__(483));

var _or = _interopRequireDefault(__webpack_require__(484));

var _and = _interopRequireDefault(__webpack_require__(485));

var _not = _interopRequireDefault(__webpack_require__(486));

var _minValue = _interopRequireDefault(__webpack_require__(487));

var _maxValue = _interopRequireDefault(__webpack_require__(488));

var _integer = _interopRequireDefault(__webpack_require__(489));

var _decimal = _interopRequireDefault(__webpack_require__(490));

var helpers = _interopRequireWildcard(__webpack_require__(465));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 467:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    idModal: {
      type: String,
      default: "deletemodal"
    },
    subContent: {
      type: String,
      default: "Do you want to delete this record? This process cannot be undone."
    }
  },
  methods: {
    cancel: function cancel() {
      $("#" + this.idModal).modal("hide");
      this.$emit("cancel");
    },
    submit: function submit() {
      $("#" + this.idModal).modal("hide");
      this.$emit("submit");
    }
  }
});

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"production","BRAND_NAME":"Trransfer","VUE_APP_GOOGLE_MAPS_KEY":"AIzaSyDwoOCBqFXIhPMWg922paZIpeVZkudwH6I","VUE_APP_BASE_API":"https://prod-gateway-opsicar.idteknologia.net","VUE_APP_AUTH_HOST":"https://authservice.trransfer.com","VUE_APP_CDN":"https://maverick-global-assets-cp52hf.s3.ap-southeast-1.amazonaws.com","VUE_APP_GOOGLE_TAG_ID":"UA-171512499-1","VUE_APP_SUPPORT_WIDGET_ID":"51000003059","VUE_APP_SUPPORT_WIDGET_SOURCE":"https://aus-widget.freshworks.com/widgets/51000003059.js"}).BUILD === 'web' ? __webpack_require__(470).withParams : __webpack_require__(235).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var emailRegex = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.withParams)({
  type: 'required'
}, function (value) {
  if (typeof value === 'string') {
    return (0, _common.req)(value.trim());
  }

  return (0, _common.req)(value);
});

exports.default = _default;

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('integer', /(^[0-9]*$)|(^-[0-9]+$)/);

exports.default = _default;

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),

/***/ 491:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteModal_vue__ = __webpack_require__(467);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6d05f94_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteModal_vue__ = __webpack_require__(492);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6d05f94_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"role":"dialog","id":_vm.idModal}},[_c('div',{staticClass:"modal-dialog modal-xs"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body modal-confirmation"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-wrapper"},[_vm._m(0),_vm._v(" "),_c('header',[_vm._v("Are you sure?")]),_vm._v(" "),_c('p',[_vm._v("\n                "+_vm._s(_vm.subContent)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v("\n                  Cancel\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"submit"},on:{"click":_vm.submit}},[_vm._v("\n                  Yes, delete\n                ")])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delete-icon"},[_c('i',{staticClass:"ic-close"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(57);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ 500:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export syncApi */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return asyncApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);



var _this = this;




var _guardCallback = function _guardCallback(arg) {
  if (typeof arg === "function") {
    arg();
  }
};

var _onError = function _onError(error) {
  if (error.response) {
    if (error.response.data.errors) {
      if (Array.isArray(error.response.data.errors)) {
        for (var index = 0; index < error.response.data.errors.length; index++) {
          __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error(error.response.data.errors[index], {
            title: "Error"
          });
        }
      } else {
        for (var prop in error.response.data.errors) {
          if (!error.response.data.errors.hasOwnProperty(prop)) {
            continue;
          }
          __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error(error.response.data.errors[prop][0], {
            title: "Error"
          });
        }
      }
    } else {
      __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error("Request failed with status code " + error.response.status, { title: "Error" });
    }
  } else if (error.request) {
    __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error("Something wrong with request messages.", {
      title: "Error"
    });
  } else {
    __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error("Something went wrong, please try again later.", {
      title: "Error"
    });
  }

  return {
    isSuccess: false
  };
};

var syncApi = {
  get: function get(url, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  post: function post(url, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  put: function put(url, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  delete: function _delete(url, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  getWithOptions: function getWithOptions(url, option, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, option).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  postWithOptions: function postWithOptions(url, option, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload, option).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  putWithOptions: function putWithOptions(url, option, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload, option).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  }
};

var asyncApi = {
  get: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(url, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              _guardCallback(onBeginCallback);
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url);

            case 4:
              response = _context.sent;
              return _context.abrupt("return", response.data);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", _onError(_context.t0));

            case 11:
              _context.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context.finish(11);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8, 11, 14]]);
    }));

    return function get(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }(),
  post: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(url, payload, onBeginCallback, onFinallyCallback, onErrorCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              _guardCallback(onBeginCallback);
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload);

            case 4:
              response = _context2.sent;
              return _context2.abrupt("return", response.data);

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);

              if (!(typeof onErrorCallback === "function")) {
                _context2.next = 12;
                break;
              }

              return _context2.abrupt("return", onErrorCallback(_context2.t0.response.data));

            case 12:
              return _context2.abrupt("return", _onError(_context2.t0));

            case 13:
              _context2.prev = 13;

              _guardCallback(onFinallyCallback);
              return _context2.finish(13);

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this, [[0, 8, 13, 16]]);
    }));

    return function post(_x4, _x5, _x6, _x7, _x8) {
      return _ref2.apply(this, arguments);
    };
  }(),
  put: function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(url, payload, onBeginCallback, onFinallyCallback, onErrorCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              _guardCallback(onBeginCallback);
              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload);

            case 4:
              response = _context3.sent;
              return _context3.abrupt("return", response.data);

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);

              if (!(typeof onErrorCallback === "function")) {
                _context3.next = 12;
                break;
              }

              return _context3.abrupt("return", onErrorCallback(_context3.t0.response.data));

            case 12:
              return _context3.abrupt("return", _onError(_context3.t0));

            case 13:
              _context3.prev = 13;

              _guardCallback(onFinallyCallback);
              return _context3.finish(13);

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this, [[0, 8, 13, 16]]);
    }));

    return function put(_x9, _x10, _x11, _x12, _x13) {
      return _ref3.apply(this, arguments);
    };
  }(),
  delete: function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(url, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;

              _guardCallback(onBeginCallback);
              _context4.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url);

            case 4:
              response = _context4.sent;
              return _context4.abrupt("return", response.data);

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);
              return _context4.abrupt("return", _onError(_context4.t0));

            case 11:
              _context4.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context4.finish(11);

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this, [[0, 8, 11, 14]]);
    }));

    return function _delete(_x14, _x15, _x16) {
      return _ref4.apply(this, arguments);
    };
  }(),
  getWithOptions: function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(url, option, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;

              _guardCallback(onBeginCallback);
              _context5.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, option);

            case 4:
              response = _context5.sent;
              return _context5.abrupt("return", response.data);

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](0);
              return _context5.abrupt("return", _onError(_context5.t0));

            case 11:
              _context5.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context5.finish(11);

            case 14:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this, [[0, 8, 11, 14]]);
    }));

    return function getWithOptions(_x17, _x18, _x19, _x20) {
      return _ref5.apply(this, arguments);
    };
  }(),
  postWithOptions: function () {
    var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(url, option, payload, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;

              _guardCallback(onBeginCallback);
              _context6.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload, option);

            case 4:
              response = _context6.sent;
              return _context6.abrupt("return", response.data);

            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](0);
              return _context6.abrupt("return", _onError(_context6.t0));

            case 11:
              _context6.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context6.finish(11);

            case 14:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this, [[0, 8, 11, 14]]);
    }));

    return function postWithOptions(_x21, _x22, _x23, _x24, _x25) {
      return _ref6.apply(this, arguments);
    };
  }(),
  putWithOptions: function () {
    var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(url, option, payload, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;

              _guardCallback(onBeginCallback);
              _context7.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload, option);

            case 4:
              response = _context7.sent;
              return _context7.abrupt("return", response.data);

            case 8:
              _context7.prev = 8;
              _context7.t0 = _context7["catch"](0);
              return _context7.abrupt("return", _onError(_context7.t0));

            case 11:
              _context7.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context7.finish(11);

            case 14:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this, [[0, 8, 11, 14]]);
    }));

    return function putWithOptions(_x26, _x27, _x28, _x29, _x30) {
      return _ref7.apply(this, arguments);
    };
  }()
};



/***/ }),

/***/ 532:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/countryPhones';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ 562:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_apiService__ = __webpack_require__(500);




var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/providers';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list' + filter)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getAllActive: function getAllActive() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/active').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getAllActiveWoSubscriber: function getAllActiveWoSubscriber() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/activewosubscriber').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getMasterOperators: function getMasterOperators(onBeginCallback, onFinallyCallback) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_3__services_apiService__["a" /* asyncApi */].get(endpoint + '/list/master-operator', onBeginCallback, onFinallyCallback));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  create: function create(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  update: function update(request) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt('return', _context6.sent);

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  delete: function _delete(id) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ('/' + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context7.abrupt('return', _context7.sent);

            case 3:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  uploadImage: function uploadImage(request) {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/image', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context8.abrupt('return', _context8.sent);

            case 3:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  }
});

/***/ }),

/***/ 740:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_DeleteModal__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_master_driver_DriverDocument__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_master_driver_driverService_js__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_master_provider_providerService_js__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_master_countryPhoneService_js__ = __webpack_require__(532);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    deleteModal: __WEBPACK_IMPORTED_MODULE_6__components_shared_DeleteModal__["a" /* default */],
    driverDocumentComponent: __WEBPACK_IMPORTED_MODULE_7__components_master_driver_DriverDocument__["a" /* default */]
  },
  computed: {
    isAllowToRead: function isAllowToRead() {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function isAllowToCreate() {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function isAllowToUpdate() {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function isAllowToDelete() {
      return this.allPermissions.includes("Delete");
    },
    isAllowToSync: function isAllowToSync() {
      return this.allPermissions.includes("Sync");
    },
    recordInfo: function recordInfo() {
      return this.table.totalRecords > 1 ? this.table.totalRecords + " Records" : this.table.totalRecords + " Record";
    },
    validationRulePassword: function validationRulePassword() {
      return !this.isUpdate ? { required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["maxLength"])(100) } : {};
    },
    validationRuleProvider: function validationRuleProvider() {
      return this.model.modifiedProviders && this.model.modifiedProviders.length > 0 ? { $each: { providerId: { required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"] } } } : { $each: { providerId: {} } };
    },
    validationRuleLanguage: function validationRuleLanguage() {
      return this.model.modifiedLanguages && this.model.modifiedLanguages.length > 0 ? { $each: { language: { required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"] }, level: { required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"] } } } : { $each: { language: {}, level: {} } };
    },
    canAddMoreProviders: function canAddMoreProviders() {
      return this.providers && this.providers.length > 1;
    },
    optionLanguage: function optionLanguage() {
      return this.cekOptionLanguage();
    },

    sanitizePhoneNumber: {
      get: function get() {
        return this.model.phoneNumber;
      },
      set: function set(value) {
        this.model.phoneNumber = value.replace(/\D/g, "");
      }
    },
    sanitizeAltPhoneNumber: {
      get: function get() {
        return this.model.alternatePhoneNumber;
      },
      set: function set(value) {
        this.model.alternatePhoneNumber = value.replace(/\D/g, "");
      }
    }
  },
  data: function data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
        sort: "",
        sortDir: ""
      },
      isSubmitted: false,
      activeTab: "general",
      publicSettings: [],
      allPermissions: [],
      isViewOnly: false,
      itemToBeDeleted: null,
      titles: [],
      providers: [],
      defaultProviderIds: [],
      items: [],
      detail: [],
      phoneCodes: [],
      languages: [],
      proficiencyLevels: [],
      deleteId: null,
      deleteOption: null,
      imagePreview: null,
      imageData: null,
      model: {},
      auth: {},
      isLoading: false,
      isUpdate: false,
      msg: "Please wait"
    };
  },
  validations: function validations() {
    return {
      model: {
        title: { required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"] },
        otherTitle: {},
        fullName: { required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["maxLength"])(150) },
        phoneCode: { required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"] },
        phoneNumber: { required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["maxLength"])(20) },
        alternatePhoneNumber: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["maxLength"])(20) },
        password: this.validationRulePassword,
        email: { required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["email"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["maxLength"])(100) },
        alternateEmail: { email: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["email"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["maxLength"])(100) },
        modifiedProviders: this.validationRuleProvider,
        modifiedLanguages: this.validationRuleLanguage
      },
      auth: {
        password: { required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["maxLength"])(100) }
      }
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      var profile, permissions;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$helper.scrollTop();
              _context.next = 3;
              return _this.$store.dispatch("setting/getAllPublic");

            case 3:
              _this.publicSettings = _context.sent;

              _this.table.pageSize = _this.$helper.extractSetting(_this.publicSettings, "PageSize", 25);

              _context.next = 7;
              return _this.$store.dispatch("user/getProfile");

            case 7:
              profile = _context.sent;
              permissions = profile.services[_this.$route.name];

              if (permissions) {
                _this.allPermissions = permissions;
              }

              if (!_this.isAllowToRead) {
                _context.next = 21;
                break;
              }

              _context.next = 13;
              return _this.getAll();

            case 13:
              _context.next = 15;
              return _this.getProviders();

            case 15:
              _context.next = 17;
              return _this.getCommon();

            case 17:
              _context.next = 19;
              return _this.getPhoneCodes();

            case 19:
              _this.titles = [{ value: "Mr", text: "Mr" }, { value: "Mrs", text: "Mrs" }, { value: "Ms", text: "Ms" }, { value: "Other", text: "Others" }];

              if (profile.selectors && profile.selectors["Providers"]) {
                _this.defaultProviderIds = profile.selectors["Providers"].ids;
              }

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    $(this.$refs.drivermodal).on("hidden.bs.modal", this.closeDriverModal);
  },
  updated: function updated() {
    // subscribe event
    this.$eventBus.$on("openDriverDeleteModal", this.openDeleteModal);
    this.$helper.collapseMenu("fleet-master");
    this.$helper.setNavigationClass("driver-link");
    this.$helper.alphabetsOnly();
    this.$helper.alphabetsCharactersOnly();
    this.$helper.numbersOnly();
    this.$helper.disableContextMenu(".readonly");
  },
  beforeDestroy: function beforeDestroy() {
    // unsubscribe event
    this.$eventBus.$off("openDriverDeleteModal");
  },

  methods: {
    cekOptionLanguage: function cekOptionLanguage() {
      var _this2 = this;

      var data = this.model.modifiedLanguages || [];
      var optLanguages = [];

      if (data.length) {
        data.forEach(function (val) {
          if (val.state !== "Deleted") {
            if (optLanguages.length) {
              optLanguages = optLanguages.filter(function (item) {
                return val.language !== item.value;
              });
            } else {
              optLanguages = _this2.languages.filter(function (item) {
                return val.language !== item.value;
              });
            }
          }
        });
        return optLanguages;
      }

      return this.languages;
    },
    onChangePageSize: function onChangePageSize() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.table.pageNumber = 1;
                _context2.next = 3;
                return _this3.getAll();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    onKeyupKeyword: function onKeyupKeyword() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var self;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                self = _this4;

                if (self.timer) {
                  clearTimeout(self.timer);
                  self.timer = null;
                }
                self.timer = setTimeout(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3(_) {
                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            self.table.pageNumber = 1;
                            _context3.next = 3;
                            return self.getAll();

                          case 3:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this4);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }(), 500);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    onNavigateCallback: function onNavigateCallback(pageNumber) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.table.pageNumber = pageNumber;
                _context5.next = 3;
                return _this5.getAll();

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    onClickSort: function onClickSort(column) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (_this6.table.sort === column) {
                  _this6.table.sortDir = _this6.table.sortDir === "asc" ? "desc" : "asc";
                } else {
                  _this6.table.sortDir = "asc";
                }
                _this6.table.sort = column;
                _context6.next = 4;
                return _this6.getAll();

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    resetModel: function resetModel() {
      this.model = {};
      this.auth = {};
    },
    resetValidations: function resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
      this.$v.auth.$reset();
    },
    searchPhoneCode: function searchPhoneCode(options, search) {
      var pattern = new RegExp(search.toLowerCase(), "i");
      return this.phoneCodes.filter(function (item) {
        return pattern.test(item.area) || pattern.test(item.country) || pattern.test(item.dial) || pattern.test(item.iata);
      });
    },
    openDriverModal: function openDriverModal(object) {
      this.resetValidations();
      this.model = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, object);
      $(this.$refs.drivermodal).modal({ backdrop: "static", keyboard: false });
    },
    closeDriverModal: function closeDriverModal() {
      var imageUploader = document.getElementById("image-uploader");
      if (imageUploader) {
        imageUploader.value = "";
      }
      this.imagePreview = null;
      this.imageData = null;
      this.resetModel();
      this.resetValidations();
      $(this.$refs.drivermodal).modal("hide");
    },
    openAuthModal: function openAuthModal(item) {
      this.resetValidations();
      this.auth = { id: item.id, password: null };
      $(this.$refs.driverpasswordmodal).modal();
    },
    closeAuthModal: function closeAuthModal() {
      this.resetModel();
      this.resetValidations();
      $(this.$refs.driverpasswordmodal).modal("hide");
    },
    submitAuth: function submitAuth() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this7.isSubmitted = true;
                _this7.$v.auth.$touch();

                if (!_this7.$v.auth.$error) {
                  _context7.next = 4;
                  break;
                }

                return _context7.abrupt("return");

              case 4:
                _context7.prev = 4;

                _this7.isLoading = true;
                _context7.next = 8;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_driver_driverService_js__["a" /* default */].syncAuth(_this7.auth);

              case 8:
                _this7.$notification.success("Successfully synced.", {
                  title: "Success"
                });
                _this7.closeAuthModal();
                _context7.next = 12;
                return _this7.getAll();

              case 12:
                _context7.next = 17;
                break;

              case 14:
                _context7.prev = 14;
                _context7.t0 = _context7["catch"](4);

                if (_context7.t0.errors) {
                  for (index = 0; index < _context7.t0.errors.length; index++) {
                    _this7.$notification.error(_context7.t0.errors[index], { title: "Error" });
                  }
                }

              case 17:
                _context7.prev = 17;

                _this7.isLoading = false;
                return _context7.finish(17);

              case 20:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this7, [[4, 14, 17, 20]]);
      }))();
    },
    createItem: function createItem() {
      var uploader = document.getElementById("image-uploader");
      if (uploader) {
        uploader.value = "";
      }
      this.isViewOnly = false;
      this.isUpdate = false;
      this.activeTab = "general";
      this.resetModel();
      var modifiedProviders = [];
      if (this.defaultProviderIds && this.defaultProviderIds.length > 0) {
        for (var i = 0; i < this.defaultProviderIds.length; i++) {
          modifiedProviders.push({
            id: this.$helper.emptyGuid(),
            providerId: this.defaultProviderIds[i],
            state: "Created"
          });
        }
      } else {
        modifiedProviders.push({
          id: this.$helper.emptyGuid(),
          providerId: null,
          state: "Created"
        });
      }
      this.openDriverModal({
        title: "Mr",
        phoneNumber: "",
        alternatePhoneNumber: "",
        modifiedProviders: modifiedProviders,
        modifiedLanguages: [{
          language: "English",
          level: "Average",
          state: "Created"
        }]
      });
    },
    updateItem: function updateItem(id) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var response, item, i, _i, index;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;

                _this8.isLoading = true;
                _context8.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_driver_driverService_js__["a" /* default */].getById(id);

              case 4:
                response = _context8.sent;
                item = response.data;

                _this8.isViewOnly = false;
                _this8.isUpdate = true;
                _this8.imagePreview = item.imageUri;
                item.modifiedProviders = [];
                item.modifiedLanguages = [];
                _this8.activeTab = "general";
                item = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item, {
                  title: _this8.findTitle(item.title, "title"),
                  otherTitle: _this8.findTitle(item.title, "otherTitle")
                });
                _this8.openDriverModal(item);
                for (i = 0; i < _this8.model.providers.length; i++) {
                  _this8.model.modifiedProviders.push({
                    id: _this8.model.providers[i].id,
                    providerId: _this8.model.providers[i].providerId,
                    state: "NoAction"
                  });
                }
                for (_i = 0; _i < _this8.model.languages.length; _i++) {
                  _this8.model.modifiedLanguages.push({
                    id: _this8.model.languages[_i].id,
                    language: _this8.model.languages[_i].language,
                    level: _this8.model.languages[_i].level,
                    state: "NoAction"
                  });
                }
                _context8.next = 21;
                break;

              case 18:
                _context8.prev = 18;
                _context8.t0 = _context8["catch"](0);

                if (_context8.t0.errors) {
                  for (index = 0; index < _context8.t0.errors.length; index++) {
                    _this8.$notification.error(_context8.t0.errors[index], { title: "Error" });
                  }
                }

              case 21:
                _context8.prev = 21;

                _this8.isLoading = false;
                return _context8.finish(21);

              case 24:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this8, [[0, 18, 21, 24]]);
      }))();
    },
    viewItem: function viewItem(id) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var response, item;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_driver_driverService_js__["a" /* default */].getById(id);

              case 2:
                response = _context9.sent;
                item = response.data;

                _this9.isViewOnly = true;
                _this9.isUpdate = false;
                _this9.imagePreview = item.imageUri;
                _this9.openDriverModal(item);

              case 8:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this9);
      }))();
    },
    findTitle: function findTitle(value, type) {
      var findTitle = this.titles.find(function (val) {
        return val.value === value;
      });

      if (type === "title") return findTitle ? value : "Other";else return findTitle ? null : value;
    },
    getAll: function getAll() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var filter, response, index;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (_this10.isAllowToRead) {
                  _context10.next = 2;
                  break;
                }

                return _context10.abrupt("return");

              case 2:
                _context10.prev = 2;

                _this10.isLoading = true;
                filter = "?page=" + _this10.table.pageNumber + "&size=" + _this10.table.pageSize;

                if (_this10.table.keyword && _this10.table.keyword !== "") {
                  filter += "&search=" + _this10.table.keyword;
                }
                if (_this10.table.sort && _this10.table.sort !== "") {
                  filter += "&sort=" + _this10.table.sort + "&sortDir=" + _this10.table.sortDir;
                }
                _context10.next = 9;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_driver_driverService_js__["a" /* default */].getAll(filter);

              case 9:
                response = _context10.sent;

                _this10.items = response.data;
                _this10.table.totalPages = response.totalPages;
                _this10.table.totalRecords = response.totalRecords;
                _context10.next = 18;
                break;

              case 15:
                _context10.prev = 15;
                _context10.t0 = _context10["catch"](2);

                if (_context10.t0.errors) {
                  for (index = 0; index < _context10.t0.errors.length; index++) {
                    _this10.$notification.error(_context10.t0.errors[index], { title: "Error" });
                  }
                }

              case 18:
                _context10.prev = 18;

                _this10.isLoading = false;
                return _context10.finish(18);

              case 21:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this10, [[2, 15, 18, 21]]);
      }))();
    },
    getCommon: function getCommon() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var common, i, language;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_driver_driverService_js__["a" /* default */].getCommon();

              case 2:
                common = _context11.sent;

                _this11.languages = common.languages;
                _this11.proficiencyLevels = common.proficiencyLevels;
                for (i = 0; i < _this11.languages.length; i++) {
                  language = _this11.languages[i];

                  language.label = _this11.humanize(language.text).trim();
                }

              case 6:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this11);
      }))();
    },
    getProviders: function getProviders() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee12() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return __WEBPACK_IMPORTED_MODULE_9__services_master_provider_providerService_js__["a" /* default */].getAllActive();

              case 2:
                _this12.providers = _context12.sent;

              case 3:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this12);
      }))();
    },
    getPhoneCodes: function getPhoneCodes() {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var i, item;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return __WEBPACK_IMPORTED_MODULE_10__services_master_countryPhoneService_js__["a" /* default */].getAll();

              case 2:
                _this13.phoneCodes = _context13.sent;


                for (i = 0; i < _this13.phoneCodes.length; i++) {
                  item = _this13.phoneCodes[i];

                  item.label = "+" + item.dial;
                  item.icon = "iti-flag " + item.iata.toLowerCase();
                }

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this13);
      }))();
    },
    submit: function submit() {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var response, index;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _this14.model.modifiedProviders = _this14.model.modifiedProviders.filter(function (x) {
                  return x.providerId;
                });
                _this14.model.email = _this14.model.email ? _this14.model.email.toLowerCase() : null;
                _this14.model.alternateEmail = _this14.model.alternateEmail ? _this14.model.alternateEmail.toLowerCase() : null;

                _this14.isSubmitted = true;
                _this14.$v.model.$touch();

                if (!_this14.$v.model.$error) {
                  _context14.next = 7;
                  break;
                }

                return _context14.abrupt("return");

              case 7:
                _context14.prev = 7;

                _this14.isLoading = true;
                _this14.model.title = _this14.model.title === "Other" ? _this14.model.otherTitle : _this14.model.title;
                _this14.model.isChangeStatus = false;
                _this14.model.providers = _this14.model.modifiedProviders;
                _this14.model.languages = _this14.model.modifiedLanguages.map(function (x) {
                  return x;
                });

                if (!_this14.isUpdate) {
                  _context14.next = 21;
                  break;
                }

                _context14.next = 16;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_driver_driverService_js__["a" /* default */].update(_this14.model);

              case 16:
                _context14.next = 18;
                return _this14.uploadImage(_this14.model.id);

              case 18:
                _this14.$notification.success("Successfully updated.", {
                  title: "Success"
                });
                _context14.next = 27;
                break;

              case 21:
                _context14.next = 23;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_driver_driverService_js__["a" /* default */].create(_this14.model);

              case 23:
                response = _context14.sent;
                _context14.next = 26;
                return _this14.uploadImage(response.data);

              case 26:
                _this14.$notification.success("Successfully added.", {
                  title: "Success"
                });

              case 27:
                _this14.closeDriverModal();
                _context14.next = 30;
                return _this14.getAll();

              case 30:
                _context14.next = 35;
                break;

              case 32:
                _context14.prev = 32;
                _context14.t0 = _context14["catch"](7);

                if (_context14.t0.errors) {
                  for (index = 0; index < _context14.t0.errors.length; index++) {
                    _this14.$notification.error(_context14.t0.errors[index], { title: "Error" });
                  }
                }

              case 35:
                _context14.prev = 35;

                _this14.isLoading = false;
                return _context14.finish(35);

              case 38:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this14, [[7, 32, 35, 38]]);
      }))();
    },
    changeStatus: function changeStatus(item) {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee15() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;

                _this15.isLoading = true;

                if (!item.isActive) {
                  _context15.next = 8;
                  break;
                }

                _context15.next = 5;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_driver_driverService_js__["a" /* default */].reactivate({ id: item.id });

              case 5:
                _this15.$notification.success("Successfully reactivated.", {
                  title: "Success"
                });
                _context15.next = 11;
                break;

              case 8:
                _context15.next = 10;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_driver_driverService_js__["a" /* default */].deactivate({ id: item.id });

              case 10:
                _this15.$notification.success("Successfully deactivated.", {
                  title: "Success"
                });

              case 11:
                _context15.next = 13;
                return _this15.getAll();

              case 13:
                _context15.next = 19;
                break;

              case 15:
                _context15.prev = 15;
                _context15.t0 = _context15["catch"](0);

                item.isActive = !item.isActive;
                if (_context15.t0.errors) {
                  for (index = 0; index < _context15.t0.errors.length; index++) {
                    _this15.$notification.error(_context15.t0.errors[index], { title: "Error" });
                  }
                }

              case 19:
                _context15.prev = 19;

                _this15.isLoading = false;
                return _context15.finish(19);

              case 22:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this15, [[0, 15, 19, 22]]);
      }))();
    },
    printPhone: function printPhone(item) {
      return item.phoneCode && item.phoneNumber && item.phoneCode.length > 0 && item.phoneNumber.length > 0 ? "(+" + item.phoneCode + ") " + item.phoneNumber : "";
    },
    onChangeImage: function onChangeImage(files) {
      var maxSize = 4 * 1024 * 1024;
      if (files[0].size > maxSize) {
        this.imagePreview = null;
        this.imageData = null;
        document.getElementById("image-uploader").value = "";
        alert("File is too big, max-size is  " + parseInt(maxSize / 1000000) + "MB.");
        return;
      }
      if (!["jpeg", "jpg", "png"].includes(files[0].name.substring(files[0].name.lastIndexOf(".") + 1).toLowerCase())) {
        this.imagePreview = null;
        this.imageData = null;
        document.getElementById("image-uploader").value = "";
        alert("Invalid file type.");
        return;
      }
      this.imagePreview = URL.createObjectURL(files[0]);
      this.imageData = files[0];
    },
    uploadImage: function uploadImage(id) {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee16() {
        var uploader, _$refs$cropper$getRes, canvas, model, formData, key, blob;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                uploader = document.getElementById("image-uploader");

                if (!(uploader.value && uploader.value !== "")) {
                  _context16.next = 13;
                  break;
                }

                _$refs$cropper$getRes = _this16.$refs.cropper.getResult(), canvas = _$refs$cropper$getRes.canvas;

                if (!canvas) {
                  _context16.next = 13;
                  break;
                }

                model = {
                  id: id
                };
                formData = new FormData();

                for (key in model) {
                  if (model.hasOwnProperty(key)) {
                    formData.append(key, model[key]);
                  }
                }
                _context16.next = 9;
                return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                  return canvas.toBlob(resolve);
                });

              case 9:
                blob = _context16.sent;

                formData.append("file", blob, _this16.imageData.name);
                _context16.next = 13;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_driver_driverService_js__["a" /* default */].uploadImage(formData);

              case 13:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, _this16);
      }))();
    },
    resetProfilePicture: function resetProfilePicture() {
      this.imageData = null;
      this.imagePreview = null;
      document.getElementById("image-uploader").value = "";
    },
    openDeleteModal: function openDeleteModal(option, id) {
      this.deleteOption = option;
      this.deleteId = id;
      $("#deletemodal").modal();
    },
    cancelDelete: function cancelDelete() {
      switch (this.deleteOption) {
        case "driverDocument":
          // publish message
          this.$eventBus.$emit("openModalDriverDocument", this.deleteId);
          break;
      }
      this.deleteId = null;
      this.deleteOption = null;
      $("#deletemodal").modal("hide");
    },
    deleteItem: function deleteItem() {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee17() {
        var index, _index;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;

                _this17.isLoading = true;
                _context17.t0 = _this17.deleteOption;
                _context17.next = _context17.t0 === "driver" ? 5 : _context17.t0 === "driverDocument" ? 17 : 19;
                break;

              case 5:
                _context17.prev = 5;
                _context17.next = 8;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_driver_driverService_js__["a" /* default */].delete(_this17.deleteId);

              case 8:
                _this17.$notification.success("Successfully deleted.", {
                  title: "Success"
                });
                _context17.next = 11;
                return _this17.getAll();

              case 11:
                _context17.next = 16;
                break;

              case 13:
                _context17.prev = 13;
                _context17.t1 = _context17["catch"](5);

                if (_context17.t1.errors) {
                  for (index = 0; index < _context17.t1.errors.length; index++) {
                    _this17.$notification.error(_context17.t1.errors[index], {
                      title: "Error"
                    });
                  }
                }

              case 16:
                return _context17.abrupt("break", 19);

              case 17:
                // publish message
                _this17.$eventBus.$emit("deleteDriverDocument", _this17.deleteId);
                return _context17.abrupt("break", 19);

              case 19:
                _this17.deleteId = null;
                _this17.deleteOption = null;
                $("#deletemodal").modal("hide");
                _context17.next = 27;
                break;

              case 24:
                _context17.prev = 24;
                _context17.t2 = _context17["catch"](0);

                if (_context17.t2.errors) {
                  for (_index = 0; _index < _context17.t2.errors.length; _index++) {
                    _this17.$notification.error(_context17.t2.errors[_index], { title: "Error" });
                  }
                }

              case 27:
                _context17.prev = 27;

                _this17.isLoading = false;
                return _context17.finish(27);

              case 30:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, _this17, [[0, 24, 27, 30], [5, 13]]);
      }))();
    },
    viewDocument: function viewDocument(item) {
      // publish message
      this.$eventBus.$emit("initializeDriverDocument", item);
    },
    printProvider: function printProvider(item) {
      return item.providers.length === 1 ? item.providers[0].providerName : item.providers.length + " providers";
    },
    printLanguage: function printLanguage(item) {
      return item.languages.length === 1 ? item.languages[0].language : item.languages.length + " languages";
    },
    addProvider: function addProvider() {
      this.model.modifiedProviders.push({
        id: this.$helper.emptyGuid(),
        providerId: null,
        state: "Created"
      });
    },
    removeProvider: function removeProvider(index) {
      this.model.modifiedProviders[index].state = "Deleted";
      var modifiedProviderData = this.model.modifiedProviders[index];
      if (!modifiedProviderData.providerId) {
        this.model.modifiedProviders.splice(index, 1);
      }
    },
    addLanguage: function addLanguage() {
      this.model.modifiedLanguages.push({
        id: this.$helper.emptyGuid(),
        language: null,
        level: null,
        state: "Created"
      });
    },
    removeLanguage: function removeLanguage(index) {
      this.model.modifiedLanguages[index].language = this.model.modifiedLanguages[index].language ? this.model.modifiedLanguages[index].language : "Unspecified";
      this.model.modifiedLanguages[index].level = this.model.modifiedLanguages[index].level ? this.model.modifiedLanguages[index].level : "Limited";
      this.model.modifiedLanguages[index].state = "Deleted";
    },
    onChangeDriverItem: function onChangeDriverItem(item) {
      if (item.id === this.$helper.emptyGuid()) {
        item.state = "Created";
      } else {
        item.state = "Updated";
      }
    },
    humanize: function humanize(value) {
      return this.$helper.humanize(value);
    }
  }
});

/***/ }),

/***/ 741:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_master_driver_driverDocumentService_js__ = __webpack_require__(928);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    isAllowToRead: function isAllowToRead() {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function isAllowToCreate() {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function isAllowToUpdate() {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function isAllowToDelete() {
      return this.allPermissions.includes("Delete");
    }
  },
  data: function data() {
    return {
      isSubmitted: false,
      allPermissions: [],
      isViewOnly: false,
      selectedDriver: null,
      document: null,
      items: [],
      model: {},
      isUpdate: false,
      isLoading: false,
      msg: "Please wait"
    };
  },
  validations: function validations() {
    return {
      model: {
        name: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) }
      }
    };
  },
  created: function created() {
    // subscribe message
    this.$eventBus.$on("initializeDriverDocument", this.initialize);
    this.$eventBus.$on("deleteDriverDocument", this.deleteItem);
    this.$eventBus.$on("openModalDriverDocument", this.openModal);
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off("initializeDriverDocument");
    this.$eventBus.$off("deleteDriverDocument");
    this.$eventBus.$off("openModalDriverDocument");
    this.closeModal();
  },

  methods: {
    openModal: function openModal() {
      $(this.$refs.driverdocumentmodal).modal({ backdrop: "static", keyboard: false });
      $(this.$refs.driverdocumentmodal).css("overflow-y", "auto");
    },
    closeModal: function closeModal() {
      $(this.$refs.driverdocumentmodal).modal("hide");
    },
    initialize: function initialize(driver) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var profile, permissions, uploader;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.isViewOnly = !driver.isOwnInventory;
                _this.isLoading = true;
                _this.reset();
                _this.selectedDriver = driver;

                _context.next = 7;
                return _this.$store.dispatch("user/getProfile");

              case 7:
                profile = _context.sent;
                permissions = profile.services["DriverDocument"];

                if (permissions) {
                  _this.allPermissions = permissions;
                }

                if (!_this.isAllowToRead) {
                  _context.next = 13;
                  break;
                }

                _context.next = 13;
                return _this.getAll();

              case 13:
                _this.openModal();
                uploader = document.getElementById("driver-document-uploader");

                if (uploader) {
                  uploader.value = "";
                }

              case 16:
                _context.prev = 16;

                _this.isLoading = false;
                return _context.finish(16);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0,, 16, 19]]);
      }))();
    },
    bindModel: function bindModel(object) {
      var uploader = document.getElementById("driver-document-uploader");
      if (uploader) {
        uploader.value = "";
      }
      this.isUpdate = true;
      this.document = null;
      this.resetValidations();
      this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, object);
    },
    reset: function reset() {
      var uploader = document.getElementById("driver-document-uploader");
      if (uploader) {
        uploader.value = "";
      }
      this.isUpdate = false;
      this.document = null;
      this.resetValidations();
      this.model = {};
    },
    resetValidations: function resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    getAll: function getAll() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_driver_driverDocumentService_js__["a" /* default */].getAll(_this2.selectedDriver.id);

              case 2:
                _this2.items = _context2.sent;

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    onChangeDocument: function onChangeDocument(files) {
      var maxSize = 4 * 1024 * 1024;
      if (files[0].size > maxSize) {
        this.document = null;
        document.getElementById("driver-document-uploader").value = "";
        alert("File is too big, max-size is  " + parseInt(maxSize / 1000000) + "MB.");
        return;
      }
      var fileExt = files[0].name.substring(files[0].name.lastIndexOf(".") + 1).toLowerCase();
      if (!["jpeg", "jpg", "png", "pdf"].includes(fileExt)) {
        this.document = null;
        document.getElementById("driver-document-uploader").value = "";
        alert("Invalid file type.");
        return;
      }
      this.document = files[0];
    },
    submit: function submit() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var formData, key, index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.isSubmitted = true;
                _this3.$v.model.$touch();

                if (!_this3.$v.model.$error) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return");

              case 4:
                _context3.prev = 4;

                _this3.isLoading = true;
                _this3.model.driverId = _this3.selectedDriver.id;

                if (_this3.isUpdate) {
                  _context3.next = 16;
                  break;
                }

                formData = new FormData();

                for (key in _this3.model) {
                  if (_this3.model.hasOwnProperty(key)) {
                    formData.append(key, _this3.model[key]);
                  }
                }
                formData.append(_this3.document.name, _this3.document);
                _context3.next = 13;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_driver_driverDocumentService_js__["a" /* default */].create(formData);

              case 13:
                _this3.$notification.success("Successfully added.", { title: "Success" });
                _context3.next = 19;
                break;

              case 16:
                _context3.next = 18;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_driver_driverDocumentService_js__["a" /* default */].update(_this3.model);

              case 18:
                _this3.$notification.success("Successfully updated.", { title: "Success" });

              case 19:
                _this3.reset();
                _context3.next = 22;
                return _this3.getAll();

              case 22:
                _context3.next = 27;
                break;

              case 24:
                _context3.prev = 24;
                _context3.t0 = _context3["catch"](4);

                if (_context3.t0.errors) {
                  for (index = 0; index < _context3.t0.errors.length; index++) {
                    _this3.$notification.error(_context3.t0.errors[index], { title: "Error" });
                  }
                }

              case 27:
                _context3.prev = 27;

                _this3.isLoading = false;
                return _context3.finish(27);

              case 30:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[4, 24, 27, 30]]);
      }))();
    },
    changeStatus: function changeStatus(item) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this4.isLoading = true;
                item.driverId = _this4.selectedDriver.id;
                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_driver_driverDocumentService_js__["a" /* default */].update(item);

              case 5:
                _this4.$notification.success("Successfully updated.", { title: "Success" });
                _this4.reset();
                _context4.next = 9;
                return _this4.getAll();

              case 9:
                _context4.next = 14;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](0);

                if (_context4.t0.errors) {
                  for (index = 0; index < _context4.t0.errors.length; index++) {
                    _this4.$notification.error(_context4.t0.errors[index], { title: "Error" });
                  }
                }

              case 14:
                _context4.prev = 14;

                _this4.isLoading = false;
                return _context4.finish(14);

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 11, 14, 17]]);
      }))();
    },
    confirmDelete: function confirmDelete(item) {
      this.closeModal();
      // publish message
      this.$eventBus.$emit("openDriverDeleteModal", "driverDocument", item.id);
    },
    deleteItem: function deleteItem(id) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                _this5.isLoading = true;
                _context5.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_driver_driverDocumentService_js__["a" /* default */].delete(id);

              case 4:
                _this5.$notification.success("Successfully deleted.", { title: "Success" });
                _this5.reset();
                _context5.next = 8;
                return _this5.getAll();

              case 8:
                _context5.next = 13;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5["catch"](0);

                if (_context5.t0.errors) {
                  for (index = 0; index < _context5.t0.errors.length; index++) {
                    _this5.$notification.error(_context5.t0.errors[index], { title: "Error" });
                  }
                }

              case 13:
                _context5.prev = 13;

                _this5.openModal();
                _this5.isLoading = false;
                return _context5.finish(13);

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 10, 13, 17]]);
      }))();
    },
    viewDocument: function viewDocument(id) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var response, index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                _this6.isLoading = true;
                _context6.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_driver_driverDocumentService_js__["a" /* default */].view(id);

              case 4:
                response = _context6.sent;

                window.open(response.data, "_blank");
                _context6.next = 11;
                break;

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6["catch"](0);

                if (_context6.t0.errors) {
                  for (index = 0; index < _context6.t0.errors.length; index++) {
                    _this6.$notification.error(_context6.t0.errors[index], { title: "Error" });
                  }
                }

              case 11:
                _context6.prev = 11;

                _this6.isLoading = false;
                return _context6.finish(11);

              case 14:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[0, 8, 11, 14]]);
      }))();
    },
    printFileSize: function printFileSize(size) {
      return this.$helper.printFileSize(size);
    }
  }
});

/***/ }),

/***/ 927:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverDocument_vue__ = __webpack_require__(741);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0623cf3c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverDocument_vue__ = __webpack_require__(929);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverDocument_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0623cf3c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DriverDocument_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 928:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/driverDocuments';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(driverId) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list/' + driverId)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  view: function view(id) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/item/' + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  create: function create(request) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  update: function update(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  delete: function _delete(id) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ('/' + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  }
});

/***/ }),

/***/ 929:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedDriver)?_c('div',[_c('div',{ref:"driverdocumentmodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header modal-new",class:{ update: _vm.isUpdate }},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("Driver Document ("+_vm._s(_vm.selectedDriver.fullName)+")")]),_vm._v(" "),(_vm.model.modifiedDate)?_c('h6',[_vm._v("\n                Last Updated: "+_vm._s(_vm.model.modifiedDate.stringFullDate)+"\n              ")]):_vm._e()]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper modal-detail"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3 divider-right pr-25"},[(_vm.$v.model.$error)?_c('div',{staticClass:"summary-error"},[_vm._v("\n                          This form has errors\n                        ")]):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",class:{
                                'field-error': _vm.isSubmitted && _vm.$v.model.name.$error,
                              },attrs:{"type":"text","disabled":_vm.isViewOnly,"autocomplete":"off"},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.model.name.$error)?_c('div',[(!_vm.$v.model.name.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Name is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.name.maxLength)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Name must be less than\n                                "+_vm._s(_vm.$v.model.name.$params.maxLength.max)+"\n                                characters")]):_vm._e()]):_vm._e()]),_vm._v(" "),(
                              !_vm.isUpdate &&
                              !_vm.isViewOnly &&
                              (_vm.isAllowToCreate || _vm.isAllowToUpdate)
                            )?_c('div',{staticClass:"mb-15",staticStyle:{"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}},[_c('input',{staticClass:"custom-file-input input-uploader",attrs:{"id":"driver-document-uploader","type":"file","accept":"image/jpeg,image/png,application/pdf,application/vnd.ms-excel","name":"document","required":""},on:{"change":function($event){return _vm.onChangeDocument($event.target.files)}}})]):_vm._e(),_vm._v(" "),(!_vm.isViewOnly && (_vm.isAllowToCreate || _vm.isAllowToUpdate))?_c('div',{staticClass:"modal-footer"},[(_vm.isAllowToCreate || _vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.reset()}}},[_vm._v("\n                              Reset\n                            ")]):_vm._e(),_vm._v(" "),(!_vm.isUpdate && _vm.isAllowToCreate)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                              Create\n                            ")]):_vm._e(),_vm._v(" "),(_vm.isUpdate && _vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                              Update\n                            ")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 divider-left pl-20"},[_c('div',{staticClass:"table-modal-detail"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-hover table-fix mtz"},[_c('thead',[_c('tr',[_c('th',{staticClass:"number"},[_vm._v("No")]),_vm._v(" "),_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Size")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Status")]),_vm._v(" "),(!_vm.isViewOnly)?_c('th',{staticClass:"text-center"},[_vm._v("Action")]):_vm._e()])]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{key:item.id},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.printFileSize(item.size)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('label',{staticClass:"cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.isActive),expression:"item.isActive"}],staticClass:"control-checkbox",attrs:{"type":"checkbox","disabled":_vm.isViewOnly || !_vm.isAllowToUpdate},domProps:{"checked":Array.isArray(item.isActive)?_vm._i(item.isActive,null)>-1:(item.isActive)},on:{"change":[function($event){var $$a=item.isActive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "isActive", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "isActive", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "isActive", $$c)}},function($event){return _vm.changeStatus(item)}]}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                                        "+_vm._s(item.isActive ? "Active" : "Inactive")+"\n                                      ")])])]),_vm._v(" "),(!_vm.isViewOnly)?_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"button-action-wrapper"},[(_vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.bindModel(item)}}},[_c('span',[_vm._v("Edit")])]):_vm._e(),_vm._v(" "),(_vm.isAllowToDelete)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item)}}},[_c('i',{staticClass:"ic-close"})]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-default --green35",attrs:{"type":"button"},on:{"click":function($event){return _vm.viewDocument(item.id)}}},[_c('span',[_vm._v("View")])])])]):_vm._e()])}),0)])])])])])])])])])])])])])]),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"ic-close"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 930:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/drivers';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list' + filter).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getById: function getById(id) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/item/id/' + id).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getCommon: function getCommon() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/common').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  create: function create(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  update: function update(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  syncAuth: function syncAuth(request) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/sync', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt('return', _context6.sent);

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  reactivate: function reactivate(request) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/reactivate', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context7.abrupt('return', _context7.sent);

            case 3:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  deactivate: function deactivate(request) {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/deactivate', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context8.abrupt('return', _context8.sent);

            case 3:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  delete: function _delete(id) {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ('/' + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context9.abrupt('return', _context9.sent);

            case 3:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  uploadImage: function uploadImage(request) {
    var _this10 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/image', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context10.abrupt('return', _context10.sent);

            case 3:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  }
});

/***/ }),

/***/ 931:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"section-header-info"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row cRow"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter pull-right"},[_c('i',{staticClass:"ic-search"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.table.keyword),expression:"table.keyword"}],staticClass:"form-control",attrs:{"type":"search","placeholder":"Search Phone Number, Provider or Driver Name"},domProps:{"value":(_vm.table.keyword)},on:{"keyup":function($event){return _vm.onKeyupKeyword()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.table, "keyword", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"content-header-info"},[_c('div',{staticClass:"col-sm-12"},[(_vm.isAllowToCreate)?_c('button',{staticClass:"btn btn-primary pull-left",on:{"click":function($event){return _vm.createItem()}}},[_c('span',[_vm._v("+")]),_vm._v(" Create New\n              ")]):_vm._e(),_vm._v(" "),_vm._m(1)])])])])])]),_vm._v(" "),_c('section',{staticClass:"middle-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row hidden"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter"},[_c('i',{staticClass:"ic-search"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.table.keyword),expression:"table.keyword"}],staticClass:"form-control",attrs:{"type":"search","placeholder":"Search Phone Number, Provider or Driver Name"},domProps:{"value":(_vm.table.keyword)},on:{"keyup":function($event){return _vm.onKeyupKeyword()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.table, "keyword", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-accordion table-p15"},[_c('table',{staticClass:"table table-hover table-striped table-sticky"},[_c('thead',[_c('tr',[_c('th',[_vm._v("\n                  Name\n                  "),_c('span',{staticClass:"button-sort",on:{"click":function($event){return _vm.onClickSort('fullName')}}},[_c('i',{staticClass:"ic-Switch-Vertical"})])]),_vm._v(" "),_c('th',[_vm._v("\n                  Phone\n                  "),_c('span',{staticClass:"button-sort",on:{"click":function($event){return _vm.onClickSort('phone')}}},[_c('i',{staticClass:"ic-Switch-Vertical"})])]),_vm._v(" "),_c('th',[_vm._v("Provider(s)")]),_vm._v(" "),_c('th',[_vm._v("Language(s)")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Source")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Status")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',{key:item.id,staticClass:"detail-row"},[_c('td',[_vm._v("\n                  "+_vm._s(item.title ? ((item.title) + ".") : "")+"\n                  "+_vm._s(item.fullName)+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"pos-rel"},[_vm._v("\n                  "+_vm._s(_vm.printPhone(item))+"\n                  "),_c('div',{staticClass:"row-big-menu"},[_c('ul',[(!item.isOwnInventory)?_c('li',[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.viewItem(item.id)}}},[_c('span',[_vm._v("View")])])]):_vm._e(),_vm._v(" "),(item.isOwnInventory && _vm.isAllowToUpdate)?_c('li',[_c('button',{staticClass:"btn btn-default --blue",attrs:{"type":"button"},on:{"click":function($event){return _vm.updateItem(item.id)}}},[_c('span',[_vm._v("Edit")])])]):_vm._e(),_vm._v(" "),(item.isOwnInventory && _vm.isAllowToDelete)?_c('li',[_c('button',{staticClass:"btn btn-default sts-danger",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.openDeleteModal('driver', item.id)}}},[_c('span',[_vm._v("Delete")])])]):_vm._e(),_vm._v(" "),(item.isOwnInventory && _vm.isAllowToUpdate)?_c('li',[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.viewDocument(item)}}},[_c('span',[_vm._v("Document")])])]):_vm._e(),_vm._v(" "),(
                          item.isOwnInventory && !item.isSync && _vm.isAllowToSync
                        )?_c('li',[_c('button',{staticClass:"btn btn-default --green35",attrs:{"type":"button"},on:{"click":function($event){return _vm.openAuthModal(item)}}},[_c('span',[_vm._v("Sync User")])])]):_vm._e()])])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.printProvider(item)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.printLanguage(item)))]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(item.source))]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_c('label',{staticClass:"cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.isActive),expression:"item.isActive"}],staticClass:"control-checkbox",attrs:{"type":"checkbox","disabled":!item.isOwnInventory || !_vm.isAllowToUpdate},domProps:{"checked":Array.isArray(item.isActive)?_vm._i(item.isActive,null)>-1:(item.isActive)},on:{"change":[function($event){var $$a=item.isActive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "isActive", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "isActive", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "isActive", $$c)}},function($event){return _vm.changeStatus(item)}]}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                      "+_vm._s(item.isActive ? "Active" : "Inactive")+"\n                    ")])])])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"dataTables_length mt-15"},[_c('label',[_vm._v("\n              Show\n              "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.table.pageSize),expression:"table.pageSize"}],staticClass:"form-control v-select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.table, "pageSize", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.onChangePageSize()}]}},_vm._l((_vm.table.pageSizes),function(item){return _c('option',{key:item,domProps:{"value":item}},[_vm._v("\n                  "+_vm._s(item)+"\n                ")])}),0),_vm._v(" "),_c('span',[_vm._v("from")]),_c('strong',{staticClass:"pl-10 --blue25"},[_vm._v(_vm._s(_vm.recordInfo))])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('nav',{attrs:{"aria-label":"..."}},[_c('paginate',{attrs:{"page-count":_vm.table.totalPages,"click-handler":_vm.onNavigateCallback,"prev-text":'Previous',"next-text":'Next',"container-class":'pagination pull-right'},model:{value:(_vm.table.pageNumber),callback:function ($$v) {_vm.$set(_vm.table, "pageNumber", $$v)},expression:"table.pageNumber"}})],1)])])])]),_vm._v(" "),_c('div',{ref:"drivermodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-sm"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header modal-new",class:{ update: _vm.isUpdate }},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("Driver")]),_vm._v(" "),(_vm.model.modifiedDate)?_c('h6',[_vm._v("\n                Last Updated: "+_vm._s(_vm.model.modifiedDate.stringFullDate)+"\n              ")]):_vm._e()]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body mt-5"},[_c('ul',{staticClass:"nav nav-tabs nav-justified nav-tab-modal tabs-mini-form"},[_c('li',{class:[_vm.activeTab === 'general' ? 'active' : '']},[_c('a',{attrs:{"href":"#driver-general","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 'general'}}},[_c('span',{staticClass:"required"},[_vm._v("General")])])]),_vm._v(" "),_c('li',{class:[_vm.activeTab === 'provider' ? 'active' : '']},[_c('a',{attrs:{"href":"#driver-provider","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 'provider'}}},[_c('span',{staticClass:"required"},[_vm._v("Provider")])])]),_vm._v(" "),_c('li',{class:[_vm.activeTab === 'language' ? 'active' : '']},[_c('a',{attrs:{"href":"#driver-language","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 'language'}}},[_c('span',{staticClass:"required"},[_vm._v("Language")])])])]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane fade",class:[_vm.activeTab === 'general' ? 'in active' : ''],attrs:{"id":"driver-general"}},[(_vm.$v.model.$error)?_c('div',{staticClass:"summary-error"},[_vm._v("\n                        This form has errors\n                      ")]):_vm._e(),_vm._v(" "),(_vm.imageData && !_vm.isViewOnly)?_c('div',[_c('cropper',{ref:"cropper",staticClass:"cropper-box",attrs:{"src":_vm.imagePreview}})],1):_vm._e(),_vm._v(" "),(!_vm.imageData && _vm.imagePreview)?_c('div',{staticClass:"logo-provider"},[_c('img',{attrs:{"src":_vm.imagePreview,"alt":"driver-picture"}})]):_vm._e(),_vm._v(" "),(!_vm.isViewOnly)?_c('div',{staticClass:"btn-upload-wrapper"},[_c('button',{staticClass:"btn btn-upload"},[_c('i',{staticClass:"ic-up"}),_vm._v("\n                          "+_vm._s(_vm.model.imageUri
                              ? "Change picture"
                              : "Upload picture")+"\n                        ")]),_vm._v(" "),_c('input',{attrs:{"id":"image-uploader","type":"file","name":"imageData","accept":"image/jpeg,image/png"},on:{"change":function($event){return _vm.onChangeImage($event.target.files)}}}),_vm._v(" "),(_vm.imageData)?_c('button',{staticClass:"btn btn-default btn-block text-center",on:{"click":function($event){return _vm.resetProfilePicture()}}},[_vm._v("\n                          Clear\n                        ")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Select Title")]),_vm._v(" "),_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},_vm._l((_vm.titles),function(item,index){return _c('label',{key:index,staticClass:"btn",class:{
                              active: _vm.model.title === item.value,
                              'field-error':
                                _vm.isSubmitted && _vm.$v.model.title.$error,
                            },on:{"click":function($event){_vm.model.title = item.value}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.title),expression:"model.title"}],attrs:{"type":"radio","autocomplete":"off"},domProps:{"value":item.value,"checked":_vm.model.title === item.value,"checked":_vm._q(_vm.model.title,item.value)},on:{"change":function($event){return _vm.$set(_vm.model, "title", item.value)}}}),_vm._v("\n                            "+_vm._s(item.text)+"\n                          ")])}),0),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.model.title.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Title is required")]):_vm._e()]),_vm._v(" "),(_vm.model.title === 'Other')?_c('div',{staticClass:"form-group"},[_c('label',{},[_vm._v("Title")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.otherTitle),expression:"model.otherTitle"}],staticClass:"form-control alphabets-only",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.model.otherTitle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "otherTitle", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Full Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.fullName),expression:"model.fullName"}],staticClass:"form-control alphabets-characters-only",class:{
                            'field-error':
                              _vm.isSubmitted && _vm.$v.model.fullName.$error,
                          },attrs:{"type":"text","autocomplete":"off","disabled":_vm.isViewOnly},domProps:{"value":(_vm.model.fullName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "fullName", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.model.fullName.$error)?_c('div',[(!_vm.$v.model.fullName.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Full Name is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.fullName.maxLength)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Full Name must be less than\n                            "+_vm._s(_vm.$v.model.fullName.$params.maxLength.max)+"\n                            characters")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"}],staticClass:"form-control",class:{
                            'field-error':
                              _vm.isSubmitted && _vm.$v.model.email.$error,
                          },attrs:{"type":"text","autocomplete":"off","disabled":_vm.isViewOnly,"placeholder":"e.g youremail@gmail.com"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.model.email.$error)?_c('div',[(!_vm.$v.model.email.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Email is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.email.email)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Email is invalid")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.email.maxLength)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Email must be less than\n                            "+_vm._s(_vm.$v.model.email.$params.maxLength.max)+"\n                            characters")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Alternate Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.alternateEmail),expression:"model.alternateEmail"}],staticClass:"form-control",class:{
                            'field-error':
                              _vm.isSubmitted && _vm.$v.model.alternateEmail.$error,
                          },attrs:{"type":"text","autocomplete":"off","disabled":_vm.isViewOnly,"placeholder":"e.g youremail@gmail.com"},domProps:{"value":(_vm.model.alternateEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "alternateEmail", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.model.alternateEmail.$error)?_c('div',[(!_vm.$v.model.alternateEmail.email)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Alt. Email is invalid")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.alternateEmail.maxLength)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Alt. Email must be less than\n                            "+_vm._s(_vm.$v.model.alternateEmail.$params.maxLength.max)+"\n                            characters")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('label',{staticClass:"required"},[_vm._v("Phone")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('v-select',{staticClass:"v-search-select",class:{
                                    'field-error':
                                      _vm.isSubmitted &&
                                      _vm.$v.model.phoneCode.$error,
                                  },attrs:{"placeholder":"Phone Code","label":"label","options":_vm.phoneCodes,"filter":_vm.searchPhoneCode,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.dial; },"disabled":_vm.isViewOnly},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_c('div',{staticClass:"phone-wrapper"},[_c('div',{staticClass:"phone-icon",class:option.icon}),_vm._v(" "),_c('div',{staticClass:"phone-text"},[_vm._v("\n                                        "+_vm._s(option.country)+"\n                                      ")])])]}}]),model:{value:(_vm.model.phoneCode),callback:function ($$v) {_vm.$set(_vm.model, "phoneCode", $$v)},expression:"model.phoneCode"}}),_vm._v(" "),(
                                    _vm.isSubmitted &&
                                    !_vm.$v.model.phoneCode.required
                                  )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Phone Code is required")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sanitizePhoneNumber),expression:"sanitizePhoneNumber"}],staticClass:"form-control numbers-only",class:{
                                    'field-error':
                                      _vm.isSubmitted &&
                                      _vm.$v.model.phoneNumber.$error,
                                  },attrs:{"type":"text","autocomplete":"off","disabled":_vm.isViewOnly},domProps:{"value":(_vm.sanitizePhoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.sanitizePhoneNumber=$event.target.value}}}),_vm._v(" "),(
                                    _vm.isSubmitted && _vm.$v.model.phoneNumber.$error
                                  )?_c('div',[(!_vm.$v.model.phoneNumber.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Phone Number is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.phoneNumber.maxLength)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Phone Number must be less than\n                                    "+_vm._s(_vm.$v.model.phoneNumber.$params.maxLength
                                        .max)+"\n                                    characters")]):_vm._e()]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('label',[_vm._v("Alt. Phone")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('v-select',{staticClass:"v-search-select",attrs:{"placeholder":"Phone Code","label":"label","options":_vm.phoneCodes,"filter":_vm.searchPhoneCode,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.dial; },"disabled":_vm.isViewOnly},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_c('div',{staticClass:"phone-wrapper"},[_c('div',{staticClass:"phone-icon",class:option.icon}),_vm._v(" "),_c('div',{staticClass:"phone-text"},[_vm._v("\n                                        "+_vm._s(option.country)+"\n                                      ")])])]}}]),model:{value:(_vm.model.alternatePhoneCode),callback:function ($$v) {_vm.$set(_vm.model, "alternatePhoneCode", $$v)},expression:"model.alternatePhoneCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sanitizeAltPhoneNumber),expression:"sanitizeAltPhoneNumber"}],staticClass:"form-control numbers-only",class:{
                                    'field-error':
                                      _vm.isSubmitted &&
                                      _vm.$v.model.alternatePhoneNumber.$error,
                                  },attrs:{"type":"text","autocomplete":"off","disabled":_vm.isViewOnly},domProps:{"value":(_vm.sanitizeAltPhoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.sanitizeAltPhoneNumber=$event.target.value}}}),_vm._v(" "),(
                                    _vm.isSubmitted &&
                                    !_vm.$v.model.alternatePhoneNumber.maxLength
                                  )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Alt. Phone Number must be less than\n                                  "+_vm._s(_vm.$v.model.alternatePhoneNumber.$params
                                      .maxLength.max)+"\n                                  characters")]):_vm._e()])])])])]),_vm._v(" "),(!_vm.isUpdate)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"}],staticClass:"form-control",class:{
                            'field-error':
                              _vm.isSubmitted && _vm.$v.model.password.$error,
                          },attrs:{"type":"password","autocomplete":"off"},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.model.password.$error)?_c('div',[(!_vm.$v.model.password.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Password is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.password.maxLength)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Password must be less than\n                            "+_vm._s(_vm.$v.model.password.$params.maxLength.max)+"\n                            characters")]):_vm._e()]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",class:[_vm.activeTab === 'provider' ? 'in active' : ''],attrs:{"id":"driver-provider"}},[(_vm.$v.model.modifiedProviders.$error)?_c('div',{staticClass:"summary-error"},[_vm._v("\n                        This form has errors\n                      ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.model.modifiedProviders),function(item,index){return _c('div',{key:index,staticClass:"row"},[(item.state !== 'Deleted')?_c('div',[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Provider")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",class:{
                                  'field-error':
                                    _vm.isSubmitted &&
                                    _vm.$v.model.modifiedProviders.$each[index]
                                      .providerId.$error,
                                },attrs:{"placeholder":"","label":"name","options":_vm.providers,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.id; },"disabled":_vm.isViewOnly},on:{"input":function($event){return _vm.onChangeDriverItem(item)}},model:{value:(item.providerId),callback:function ($$v) {_vm.$set(item, "providerId", $$v)},expression:"item.providerId"}}),_vm._v(" "),(
                                  !_vm.$v.model.modifiedProviders.$each[index]
                                    .providerId.required
                                )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Provider is required")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[(
                                  _vm.model.modifiedProviders &&
                                  _vm.model.modifiedProviders.length > 1 &&
                                  index > 0
                                )?_c('button',{staticClass:"btn btn-default sts-danger",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.removeProvider(index)}}},[_vm._v("\n                                Remove\n                              ")]):_vm._e()])])]):_vm._e()])}),_vm._v(" "),(_vm.canAddMoreProviders)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.model.modifiedProviders)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.addProvider()}}},[_vm._v("\n                            Add\n                          ")]):_vm._e()])]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",class:[_vm.activeTab === 'language' ? 'in active' : ''],attrs:{"id":"driver-language"}},[(_vm.$v.model.modifiedLanguages.$error)?_c('div',{staticClass:"summary-error"},[_vm._v("\n                        This form has errors\n                      ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.model.modifiedLanguages),function(item,index){return _c('div',{key:index,staticClass:"row"},[(item.state !== 'Deleted')?_c('div',[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Language")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",class:{
                                  'field-error':
                                    _vm.isSubmitted &&
                                    _vm.$v.model.modifiedLanguages.$each[index]
                                      .language.$error,
                                },attrs:{"placeholder":"","label":"label","options":_vm.optionLanguage,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.text; },"disabled":_vm.isViewOnly},on:{"input":function($event){return _vm.onChangeDriverItem(item)}},model:{value:(item.language),callback:function ($$v) {_vm.$set(item, "language", $$v)},expression:"item.language"}}),_vm._v(" "),(
                                  !_vm.$v.model.modifiedLanguages.$each[index]
                                    .language.required
                                )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Language is required")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Level")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",class:{
                                  'field-error':
                                    _vm.isSubmitted &&
                                    _vm.$v.model.modifiedLanguages.$each[index]
                                      .level.$error,
                                },attrs:{"placeholder":"","label":"text","options":_vm.proficiencyLevels,"clearable":false,"searchable":true,"filterable":true,"reduce":function (option) { return option.text; },"disabled":_vm.isViewOnly},on:{"input":function($event){return _vm.onChangeDriverItem(item)}},model:{value:(item.level),callback:function ($$v) {_vm.$set(item, "level", $$v)},expression:"item.level"}}),_vm._v(" "),(
                                  !_vm.$v.model.modifiedLanguages.$each[index]
                                    .level.required
                                )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Level is required")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[(
                                  _vm.model.modifiedLanguages &&
                                  _vm.model.modifiedLanguages.length > 0
                                )?_c('button',{staticClass:"btn btn-default sts-danger",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.removeLanguage(index)}}},[_vm._v("\n                                Remove\n                              ")]):_vm._e()])])]):_vm._e()])}),_vm._v(" "),(_vm.languages && _vm.model.modifiedLanguages)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.model.modifiedLanguages)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.addLanguage()}}},[_vm._v("\n                            Add\n                          ")]):_vm._e()])]):_vm._e()],2)]),_vm._v(" "),(!_vm.isViewOnly)?_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                      "+_vm._s(_vm.isUpdate ? "Save Changes" : "Save")+"\n                    ")])]):_vm._e()])])])])])])])]),_vm._v(" "),_c('div',{ref:"driverpasswordmodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-xs"},[_c('div',{staticClass:"modal-content"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body"},[(_vm.$v.auth.$error)?_c('div',{staticClass:"summary-error"},[_vm._v("\n                  This form has errors\n                ")]):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitAuth()}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.auth.password),expression:"auth.password"}],staticClass:"form-control",class:{
                        'field-error': _vm.isSubmitted && _vm.$v.auth.password.$error,
                      },attrs:{"type":"password"},domProps:{"value":(_vm.auth.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.auth, "password", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.auth.password.$error)?_c('div',[(!_vm.$v.auth.password.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Password is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.auth.password.maxLength)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Password must be less than\n                        "+_vm._s(_vm.$v.auth.password.$params.maxLength.max)+"\n                        characters")]):_vm._e()]):_vm._e()]),_vm._v(" "),_vm._m(4)])])])])])])])]),_vm._v(" "),_c('deleteModal',{on:{"submit":_vm.deleteItem,"cancel":_vm.cancelDelete}}),_vm._v(" "),_c('driverDocumentComponent'),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6"},[_c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb"},[_c('li',{staticClass:"breadcrumb-item"},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Fleet Master")])]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("\n                Drivers\n              ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl-30 pull-left"},[_c('h2',[_vm._v("\n                  Drivers "),_c('span',[_c('i',{staticClass:"ic-car"})])]),_vm._v(" "),_c('p',[_vm._v("\n                  Manage and review your drivers. Drivers can be added here or\n                  self-register through the driver mobile app.\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"ic-close"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("Driver Authentication")]),_vm._v(" "),_c('h6',[_vm._v("Please fill all information below.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"ic-close"})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                      Save Password\n                    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/32.92fb71f0410f97bb085f.js